import { getLinks } from "@cinch-nx/data-storyblok";
import { genericArticleStaticPaths } from "./data/articles-data";
export const getStaticPathsGenerator = (slug)=>async ()=>{
        try {
            const links = await getLinks(slug);
            const paths = genericArticleStaticPaths({
                links,
                type: slug
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };
